
























































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { UploadFile } from "@/request/common";
import { mixins } from "vue-class-component";
import { caijiMixin } from "./take-photos-video/caijiMixin";
import echarts from "echarts";
@Component({})
export default class Name extends mixins(caijiMixin) {
  @Prop()
  private ifReadOne: any; // 是否是单题查看详情，是的话需要隐藏题目前的题号和上一题、下一题按钮
  @Prop()
  private source: any;
  @Prop()
  private type: any;
  @Prop()
  private data: any;
  @Watch("data", { immediate: true })
  private dataChange() {
    this.imgIndex = 0;
    this.resetMai();
    (this.$refs.sizhenCaiji as any).imgs = JSON.parse(
      JSON.stringify(this.data[this.questionIndex]["pic_urls"])
    );
    setTimeout(() => {
      this.$forceUpdate();
    }, 500);
    this.countHeight();
  }
  @Prop()
  private questionIndex: any;
  @Watch("questionIndex", { immediate: true })
  private questionIndexChange() {
    this.resetMai();
  }
  @Prop()
  private IfExam: any; // 是否是考试，为true时会显示我要交卷按钮
  private maxH: any = null; // 图片的最大高度
  private ifShowJiaojuan: any = false;
  private imgIndex: any = 0;
  private fileList: any = [];
  private ifShowFileList: any = false;
  private timer: any = null;
  private chartInstance: any = null; // 添加chart实例变量
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private resetMai() {
    const cData = this.data[this.questionIndex];
    console.log("当前数据");
    console.log(cData);
    // 先清理之前的波形图
    this.clearMai();
    // 如果是脉图题目，再绘制新的波形图
    if (cData && (cData["大类"] == "脉" || cData["类别"] == "脉")) {
      this.$nextTick(() => {
        this.drawMai();
      });
    }
  }
  private drawMai() {
    console.log("画波形图");
    // 确保DOM元素存在
    if (!this.$refs.mai) {
      return;
    }
    this.timer = null;
    const cData: any = this.data[this.questionIndex];
    let maiData: any = {
      data: cData["脉象波形数据"] ? JSON.parse(cData["脉象波形数据"]) : [],
    };
    // let maiData = {
    //   originData: val,
    //   maitu: val.data["脉象图谱"] || {},
    //   tip: val.tip,
    //   cun: val.data["脉诊设置"]["寸"] || 20,
    //   guan: val.data["脉诊设置"]["关"] || 20,
    //   chi: val.data["脉诊设置"]["尺"] || 20,
    //   data: val.data["脉象波形数据"]
    //     ? JSON.parse(val.data["脉象波形数据"])
    //     : [],
    // };
    // 设置波形数据的默认值
    if (!maiData.data || maiData.data.length == 0) {
      maiData.data = [
        [0, 0],
        [4, 2],
        [9, 7],
        [11, 15],
        [20, 70],
        [34, 40],
        [58, 38],
        [77, 24],
        [94, 26],
        [113, 13],
        [143, 4],
        [158, 4],
        [170, 1],
        [180, 0],
      ];
    }
    console.log(maiData);
    this.$nextTick(() => {
      if (this.chartInstance) {
        this.chartInstance.dispose();
      }
      this.chartInstance = echarts.init(this.$refs.mai as HTMLCanvasElement);
      const options: any = {
        color: "#1B5AB2",
        yAxis: {
          type: "value",
          show: true,
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "solid",
              color: "#E9E9E9",
            },
          },
        },
        xAxis: {
          type: "category",
          show: false,
          data: [],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
        },
        series: [
          {
            data: [],
            type: "line",
            showSymbol: false,
            smooth: true,
            smoothMonotone: "x", // 保持曲线单调性
            lineStyle: {
              width: 2, // 加粗线条
            },
            animation: false, // 关闭动画使移动更流畅
          },
        ],
      };
      this.chartInstance.setOption(options);
      if (!maiData.data || maiData.data.length == 0) {
        return;
      }

      let currentIndex = 0;
      const data = maiData.data;
      const pointsPerFrame = 1; // 降低每次移动的点数
      const totalPoints = 40; // 增加显示的点数，使曲线更完整

      this.timer = setInterval(() => {
        const xData = [];
        const yData = [];

        for (let i = 0; i < totalPoints; i++) {
          const dataIndex = (currentIndex + i) % data.length;
          xData.push(data[dataIndex][0]);
          yData.push(data[dataIndex][1]);
        }

        this.chartInstance.setOption({
          xAxis: {
            data: xData,
          },
          series: [
            {
              data: yData,
            },
          ],
        });

        currentIndex = (currentIndex + pointsPerFrame) % data.length;
      }, 400); // 降低更新频率
    });
  }
  private clearMai() {
    // 关闭定时器
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    // 销毁图表实例
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
  }
  private changeImgIndex(index: any) {
    console.log(index);
    this.imgIndex = index;
  }
  private uploadSure() {
    this.$emit("addOne", JSON.parse(JSON.stringify(this.fileList)));
    this.fileList = [];
    this.ifShowFileList = false;
  }
  private goBefore() {
    this.imgIndex = 0;
    this.$emit("goBefore");
  }
  private addOneEmpty() {
    if (this.data[this.questionIndex].question_template_id == "moni") {
      this.$message.warning("请先上传本题的" + this.type + "图");
      return;
    }
    this.$emit("addEmptyOne");
  }
  delOne() {
    this.$confirm("确定要删除当前题目吗？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      this.$emit("delOne");
    });
  }
  private goNext() {
    this.imgIndex = 0;
    this.$emit("goNext");
  }
  // private preview(url: any) {
  //   window.open(url);
  // }
  updateImg(data: any) {
    console.log(data);
    this.$emit("addOne", data);
  }
  private upload(file: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("type", "file");
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    UploadFile(this, form, loading)
      .then((res: any) => {
        loading.close();
        this.$emit("addOne", [res.full_file_url]);
      })
      .catch(() => {
        loading.close();
      });
  }
  private uploadMore(file: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("type", "file");
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    UploadFile(this, form, loading)
      .then((res: any) => {
        loading.close();
        this.fileList.push(res.full_file_url);
        this.ifShowFileList = true;
      })
      .catch(() => {
        loading.close();
      });
  }
  private countHeight() {
    if (this.$refs.imgBox) {
      const box = (this.$refs.imgBox as any).offsetHeight;
      this.maxH = box;
    }
    this.$forceUpdate();
  }
  private tijiao() {
    this.ifShowJiaojuan = true;
  }
  save() {
    this.ifShowJiaojuan = false;
    this.$emit("save");
  }
  private mounted() {
    window.onresize = () => {
      //屏幕尺寸变化就重新计算时间轴
      return (() => {
        this.countHeight();
      })();
    };
  }
  private beforeDestroy() {
    // 组件销毁时清理资源
    this.clearMai();
  }
}
